import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import { Field, change, untouch, touch } from 'redux-form';
import { changeScreen } from '../../redux/actions/user-flow/user-flow-action';
import {
  setReduxFields,
  untouchFields,
  addSiftScript,
  compileTemplateNew
} from '../../utils/library';
import {
  fieldsRenderer,
  shouldDisableFields,
  processesdScreenConfig
} from '../../utils/document-upload/document-upload';
import {
  APPLICANT_POA,
  APPLICANT_POI,
  FATCA_DECLARATION,
  INDIVIDUAL_POA,
  INDIVIDUAL_POI,
  REPRESENTATIVE_POA,
  REPRESENTATIVE_POI,
  INDIVIDUAL_PERSONAL_IMAGE,
  SCREEN_NAME_DOCUMENT_UPLOAD,
  SCREEN_NAME_PHOTO_UPLOAD,
  SCREEN_NAME_FATCA,
  FORMNAME_RFI,
  CORPORATE,
  INDIVIDUAL,
  EU_REGION,
  PAN_CODE,
  SAMPLE_DOC_IMAGE,
  RFIDATA,
  ADDRESS_POA_DOCUMENT,
  ADDRESS_WITH_SUPPORTING_DOCS,
  NOTE_NRIC,
  BANK_STATEMENT_INSTRUCTIONS,
  SUPPORTED_BANK_STATEMENT_DOC_TYPES,
  SINGPASS_CODE,
  ACKNOWLEDGED,
  MALAYSIA_VIEW_SAMPLE_MODAL_DATA,
  BASE_CDN_IMAGE_URL
} from '../../utils/constants';
import '../../screens/user-flow/individual/individual-documents-upload/individual-documents-upload.scss';
import './upload-documents.scss';
import FileUploadLinksNew from '../../components/file-upload-links/FileUploadLinksNew';
import Everify from '../../components/e-verify/EverifyNew';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { UploadDocsFields } from './uploadDocsFileds';
import CommonButton from '../../components/common-button/CommonButton';
import {
  ACCEPT_ICON,
  CLOSE_HEAVY_ICON,
  INFO_NEW_ICON,
  PINK_ELIPSE_ICON,
  REJECT_ICON,
  SAMPLE,
  YOUR_SIGNATURE_ICON,
  BANK_STATEMENT_SAMPLE
} from '@Images';
import { ModalFactory } from '../../components/modal/modal';
import { HelpCenterDeepLink } from '../deeplink-help-center/HelpCenterDeepLink';

const infoPoints = {
  PAN: [
    { text: 'Should be visible & clearly readable', type: 'accept' },
    { text: 'We accept digital or scanned copy', type: 'accept' },
    { text: 'Can’t be cropped or blurry', type: 'reject' },
    { text: 'No photo or copy of a photocopy', type: 'reject' }
  ],
  DRIVING_LICENSE: [
    { text: 'Document should be self attested by you', type: 'accept' },
    { text: 'Must reflect your name', type: 'accept' },
    { text: 'Should match with address provided', type: 'accept' },
    { text: 'Should be visible & clearly readable', type: 'accept' },
    { text: 'Can’t be cropped or blurry', type: 'reject' }
  ],
  PASSPORT: [
    { text: 'Document should be self attested by you', type: 'accept' },
    { text: 'Must reflect your name', type: 'accept' },
    { text: 'Should match with address provided', type: 'accept' },
    { text: 'Should be visible & clearly readable', type: 'accept' },
    { text: 'Can’t be cropped or blurry', type: 'reject' }
  ],
  VOTER_ID: [
    { text: 'Document should be self attested by you', type: 'accept' },
    { text: 'Must reflect your name', type: 'accept' },
    { text: 'Should match with address provided', type: 'accept' },
    { text: 'Should be visible & clearly readable', type: 'accept' },
    { text: 'Can’t be cropped or blurry', type: 'reject' }
  ]
};

class UploadDocuments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldscustom: null,
      isEverificationSuccessful: true,
      isShowSamplePhotograph: true,
      sampleImageUrl: SAMPLE,
      radioNestedFields: {},
      selectedNestedRadioField: {},
      renderingRadioNestedFields: [],
      selectedSampleModal: null,
      nestedRadioParentDoc: null
    };
    this.VALID_INDIVIDUAL_DOC_TYPES = [INDIVIDUAL_POI, INDIVIDUAL_POA, FATCA_DECLARATION];
    this.POI_DOCS = [INDIVIDUAL_POI, APPLICANT_POI, REPRESENTATIVE_POI];
    this.POA_DOCS = [INDIVIDUAL_POA, APPLICANT_POA, REPRESENTATIVE_POA];
    this.PERSONAL_IMG_DOCS = [INDIVIDUAL_PERSONAL_IMAGE];
    this.FATCA_DOC = [FATCA_DECLARATION];
    this.reRenderOnUpdate = props.reRenderOnUpdate;
  }

  resetNestedRadioFields() {
    /* User has either submitted RFI or its going to NEXT Rfi */
    this.setState({
      radioNestedFields: {},
      selectedNestedRadioField: {},
      renderingRadioNestedFields: [],
      selectedSampleModal: null
    });
  }

  UNSAFE_componentWillMount = () => {
    addSiftScript();
    const fieldscustom = this.renderFieldsNew(this.props.processesdConfig);
    if (this.props.disableForm) {
      fieldscustom.disableForm = this.props.disableForm;
    }
    this.setState({ fieldscustom });
  };
  prefillPOAFields = () => {
    const { userAddress, dispatch, formName } = this.props;
    if (userAddress) {
      const poaDocs = this.state.fieldscustom?.POA || [];
      poaDocs.forEach((doc) => {
        const poaFields = doc.fields || [];

        poaFields.forEach((fieldElement) => {
          const fullKey = fieldElement.key;
          if (!fullKey) return;
          const simpleFieldName = fullKey.split('.').pop();
          if (simpleFieldName && userAddress?.[simpleFieldName]) {
            dispatch(change(formName, fullKey, userAddress[simpleFieldName]));
          }
        });
      });
    }
  };

  componentDidMount = () => {
    if (
      [ADDRESS_WITH_SUPPORTING_DOCS, ADDRESS_POA_DOCUMENT].includes(
        this.props.processesdConfig?.[0]?.[1]?.[0]?.document_code
      )
    )
      this.props.fetchUserAddress();
  };

  componentDidUpdate(prevProps) {
    const reRenderChanged =
      JSON.stringify(this.props.reRenderOnUpdate) !== JSON.stringify(prevProps.reRenderOnUpdate);

    const addressArrived =
      this.props.userAddress && this.props.userAddress !== prevProps.userAddress;

    if (!reRenderChanged && !addressArrived) return;

    const documentCode = this.props.processesdConfig?.[0]?.[1]?.[0]?.document_code;

    const shouldPrefillAddress =
      this.props.processesdConfig?.[0]?.[1]?.[0]?.additional_info?.pre_populate_address;

    if ([ADDRESS_WITH_SUPPORTING_DOCS, ADDRESS_POA_DOCUMENT].includes(documentCode)) {
      this.props.fetchUserAddress();
    }

    this.resetNestedRadioFields();
    this.props.setResetRadioQuestionField?.(null);

    const fieldscustom = this.renderFieldsNew();
    if (this.props.disableForm) {
      fieldscustom.disableForm = this.props.disableForm;
    }

    this.setState({ fieldscustom }, () => {
      if (shouldPrefillAddress && this.props.userAddress) {
        this.prefillPOAFields();
      }
    });
  }

  getTypeOfRfi = (radioButton) => {
    let type = null;
    // Check for SINGPASS FLOW IF APPLICABLE
    type = radioButton?.values?.some((item) => item.code === SINGPASS_CODE) ? SINGPASS_CODE : null;
    // For future ekyc RFI we can check for another types here and return those
    return type;
  };

  onRadioButtonChangedNestedFields = (radioButton) => {
    const { dispatch, formName, getAllformVal } = this.props;
    const radioKycType = {
      enabled: !!radioButton?.values && radioButton?.values?.length > 0,
      typeOfRfi: this.getTypeOfRfi(radioButton),
      radioObject: radioButton
    };
    this.props.setResetRadioKycScenario?.(radioKycType);
    const nestedFieldsToRender = this.state.radioNestedFields?.[0]?.[radioButton?.value] || [];
    //Reset all nested fields on radio change.
    nestedFieldsToRender?.forEach((field) => {
      dispatch(change(formName, field.field_name, null));
      dispatch(untouch(formName, field.field_name));
    });
    const resolvedSampleModal = MALAYSIA_VIEW_SAMPLE_MODAL_DATA[radioButton?.value] || null;
    //Fetch new nested fields of selected radio button
    const renderingRadioNestedFields = fieldsRenderer(nestedFieldsToRender, false, getAllformVal, {
      dispatch,
      change,
      formName,
      onViewSampleClick: () => {
        this.renderNestedSampleModal();
      }
    });

    // Reset uploaded image when switching between nested radio options
    const { nestedRadioParentDoc } = this.state;
    if (nestedRadioParentDoc) {
      const { docTypeString, document_code } = nestedRadioParentDoc;
      const docIndex = (this.state.fieldscustom[docTypeString] || []).findIndex(
        (docEle) => docEle.document_code === document_code
      );
      if (docIndex !== -1) {
        this.clearFile({
          docType: docTypeString,
          index: docIndex,
          setState: false,
          shouldUntouch: true
        });
      }
    }

    this.setState({
      renderingRadioNestedFields,
      selectedNestedRadioField: nestedFieldsToRender?.allFields || {},
      selectedSampleModal: resolvedSampleModal,
      fieldscustom: { ...(this.state.fieldscustom || {}) }
    });
  };

  hasRadioWithNestedFields = (fieldsConfig) => {
    return fieldsConfig?.some((field) => {
      if (field.category === 'radio') {
        return field.values?.some(
          (value) =>
            Array.isArray(value.nested_fields_json) &&
            value.nested_fields_json?.length > 0 &&
            !value.values
        );
      }
      return false;
    });
  };
  storeNestedFields = (fields_json, docTypeString, document_code) => {
    const radioNestedFields = {};
    fields_json?.forEach((field, index) => {
      if (field.category === 'radio') {
        radioNestedFields[index] = {};
        field.values?.forEach((value) => {
          if (Array.isArray(value.nested_fields_json) && value.nested_fields_json?.length > 0) {
            radioNestedFields[index][value.value] = value.nested_fields_json;
            const valueDeepCopy = cloneDeep(value);
            delete valueDeepCopy.nested_fields_json; //To avoid recursive deep clonning
            radioNestedFields[index][value.value].allFields = valueDeepCopy;
          }
        });
      }
    });
    this.setState({ radioNestedFields, nestedRadioParentDoc: { docTypeString, document_code } });
  };

  //RENDERFIELDS CUSTOM
  renderFieldsNew = (processesdConfig = this.props.processesdConfig) => {
    const {
        currentScreen,
        documentDetails,
        dispatch,
        formName,
        getAllformVal,
        disableDocs,
        remitterCountryCode
      } = this.props,
      //loop on sequence
      renderObj = {
        POI: [],
        POA: [],
        PERSONAL_IMAGE: [],
        FATCA: [],
        disableForm: null,
        CORP: []
      };
    Object.keys(processesdConfig).forEach((doctype) => {
      if (
        ((this.POI_DOCS.includes(doctype) || this.POA_DOCS.includes(doctype)) &&
          currentScreen === SCREEN_NAME_DOCUMENT_UPLOAD) ||
        formName === FORMNAME_RFI
      ) {
        Object.keys(processesdConfig[doctype]).forEach((seq, index) => {
          const docTypeString = this.POI_DOCS.includes(doctype) ? 'POI' : 'POA';
          const loopArr = processesdConfig[doctype][seq];
          // if user is all those checks and user is from onfido check is created then he should be not be able move
          // individaul && eu region && document code === PIN

          const disableFieldsConfig =
            this.props.account_type === INDIVIDUAL &&
            EU_REGION.includes(this.props.country_code) &&
            this.props.processesdConfig.INDIVIDUAL_POI.length > 0 &&
            this.props.processesdConfig.INDIVIDUAL_POI[0].document_code ===
              'PERSONAL_IDENTIFICATION_NUMBER'
              ? shouldDisableFields(documentDetails, doctype, dispatch, disableDocs)
              : {
                  disableForm: false,
                  disableFields: false,
                  disableLinks: false
                };
          let { disableForm } = disableFieldsConfig;
          const { disableFields, disableLinks } = disableFieldsConfig;
          disableForm
            ? renderObj.disableForm !== false
              ? (renderObj.disableForm = true)
              : (renderObj.disableForm = false)
            : (renderObj.disableForm = false);
          if (loopArr.length >= 2) {
            //radio buttons required as multiple docs for same code;
            const selectedData =
              getAllformVal && getAllformVal[`${doctype}_btn_radio`]
                ? getAllformVal[`${doctype}_btn_radio`]
                : null;
            const radioMapping = this.renderRadioButtonsNew({
              loopArr,
              docTypeString,
              disableForm,
              selectedData
            });
            const checkedIndex = radioMapping.findIndex((ele) => ele.checked);
            const {
              label,
              document_description,
              links,
              fields,
              document_code,
              linkConfig,
              additionalFieldsRender
            } = radioMapping[checkedIndex]; //take first element as default
            const radioGroup = radioMapping.map((key) => {
              return key.radioInput;
            });
            renderObj[docTypeString].push({
              radioMapping,
              radioGroup,
              label,
              document_description,
              links,
              fields,
              document_code,
              radioConfig: loopArr,
              linkConfig,
              document_type: doctype,
              additionalFieldsRender
            });
          } else {
            const fields_config = loopArr[0].fields_json; //as only one index;
            const { label, document_description, document_code } = loopArr[0];
            let verifyBtn,
              links = [];
            if (loopArr[0].everification_meta) {
              verifyBtn = this.renderEverificationBtn(loopArr[0], formName);
            }
            links = this.renderUploadLinks({
              linkEle: loopArr[0],
              docTypeString,
              index,
              disableForm: disableLinks || disableForm
            });
            if (document_code === PAN_CODE) {
              const panDetails = find(documentDetails, {
                document_code: PAN_CODE
              });
              if (!isEmpty(panDetails) && panDetails.is_everified) {
                disableForm = true;
              }
            }
            let additionalFieldsRender = null;
            if (
              remitterCountryCode === 'IN' &&
              this.props.currentScreen === SCREEN_NAME_DOCUMENT_UPLOAD
            ) {
              additionalFieldsRender = this.renderAdditionNotesAndViewSample(loopArr[0]);
            }
            if (this.hasRadioWithNestedFields(fields_config)) {
              this.props.setResetRadioQuestionField(fields_config?.[0]?.name || null);
              this.storeNestedFields(fields_config, docTypeString, loopArr[0].document_code);
            }
            const shouldPrefillAddress =
              this.props.processesdConfig?.[0]?.[1]?.[0]?.additional_info?.pre_populate_address;
            const fields = fieldsRenderer(
              fields_config,
              disableFields || disableForm,
              getAllformVal,
              {
                dispatch,
                change,
                formName,
                loopArr,
                userAddress: this.props.userAddress,
                shouldPrefillAddress
              },
              this.onRadioButtonChangedNestedFields
            );
            renderObj[docTypeString].push({
              label,
              document_description,
              fields,
              links,
              document_code,
              seq,
              linkConfig: loopArr[0],
              verifyBtn,
              additionalFieldsRender
            });
          }
        });
      } else if (
        this.PERSONAL_IMG_DOCS.includes(doctype) &&
        currentScreen === SCREEN_NAME_PHOTO_UPLOAD
      ) {
        // FOR PERSONAL IMG
        Object.keys(processesdConfig[doctype]).forEach((seq, index) => {
          const { disableForm } = shouldDisableFields(
            documentDetails,
            doctype,
            dispatch,
            disableDocs
          );
          disableForm
            ? renderObj.disableForm !== false
              ? (renderObj.disableForm = true)
              : (renderObj.disableForm = false)
            : (renderObj.disableForm = false);
          const docTypeString = 'PERSONAL_IMAGE';
          const loopArr = processesdConfig[doctype][seq];
          const { label, document_description, document_code } = loopArr[0],
            links = this.renderUploadLinks({
              linkEle: loopArr[0],
              docTypeString,
              index,
              disableForm
            });
          renderObj[docTypeString].push({
            label,
            document_description,
            links,
            document_code,
            seq,
            linkConfig: loopArr[0],
            document_type: doctype
          });
        });
      } else if (this.FATCA_DOC.includes(doctype) && currentScreen === SCREEN_NAME_FATCA) {
        //FATCA HANDLING
        Object.keys(processesdConfig[doctype]).forEach((seq) => {
          const { disableForm } = shouldDisableFields(
            documentDetails,
            doctype,
            dispatch,
            disableDocs
          );
          disableForm
            ? renderObj.disableForm !== false
              ? (renderObj.disableForm = true)
              : (renderObj.disableForm = false)
            : (renderObj.disableForm = false);
          const docTypeString = 'FATCA';
          const setObj = {};
          const loopArr = processesdConfig[doctype][seq];
          const fields_config = loopArr[0].fields_json; //as only one index;
          const { label, document_description, document_code } = loopArr[0],
            fields = fieldsRenderer(fields_config, disableForm, getAllformVal, {
              dispatch,
              change,
              formName
            });
          renderObj[docTypeString].push({
            label,
            document_description,
            fields,
            document_code,
            seq,
            linkConfig: loopArr[0],
            document_type: doctype
          });
          loopArr[0].fields_json.forEach((radio) => {
            // radio initialization
            radio.values.forEach((v) => {
              setObj[radio.field_name] = v.value && v.checked;
            });
            setReduxFields(this.props.dispatch, change, this.props.formName, setObj);
          });
        });
      } else if (
        ![SCREEN_NAME_FATCA, SCREEN_NAME_PHOTO_UPLOAD, SCREEN_NAME_DOCUMENT_UPLOAD].includes(
          currentScreen
        )
      ) {
        //corp upload
        Object.keys(processesdConfig[doctype]).forEach((seq) => {
          const docTypeString = 'CORP';
          const loopArr = processesdConfig[doctype][seq];
          const { disableForm } = shouldDisableFields(
            documentDetails,
            doctype,
            dispatch,
            disableDocs,
            true
          ); // donot disable for corporate
          disableForm
            ? renderObj.disableForm !== false
              ? (renderObj.disableForm = true)
              : (renderObj.disableForm = false)
            : (renderObj.disableForm = false);
          if (loopArr.length >= 2) {
            //radio buttons required as multiple docs for same code;
            const radioMapping = this.renderRadioButtonsNew({
              loopArr,
              docTypeString,
              disableForm
            });
            const checkedIndex = radioMapping.findIndex((ele) => ele.checked);
            const { label, document_description, links, fields, document_code, linkConfig } =
              radioMapping[checkedIndex];
            //take first element as default
            const radioGroup = radioMapping.map((key) => {
              return key.radioInput;
            });
            renderObj[docTypeString].push({
              radioMapping,
              radioGroup,
              label,
              document_description,
              links,
              fields,
              document_code,
              radioConfig: loopArr,
              linkConfig,
              document_type: doctype
            });
          } else {
            const fields_config = loopArr[0].fields_json; //as only one index;
            const { label, document_description, document_code } = loopArr[0],
              index = renderObj[docTypeString].length,
              links = this.renderUploadLinks({
                linkEle: loopArr[0],
                docTypeString,
                index,
                disableForm
              }),
              fields = fieldsRenderer(fields_config, disableForm, getAllformVal, {
                dispatch,
                change,
                formName,
                isCorp: true
              });
            renderObj[docTypeString].push({
              label,
              document_description,
              fields,
              links,
              document_code,
              seq,
              linkConfig: loopArr[0],
              document_type: doctype
            });
          }
        });
      }
    });

    return { ...renderObj, disableForm: false };
  };

  renderRadioButtonsNew = ({
    loopArr,
    changedRadioIndex,
    docTypeString,
    disableForm,
    selectedData = undefined
  }) => {
    const generateRadioFields = (radioEle) => (
      <label className="label-radio" key={`radio-${radioEle.type}-${radioEle.index}`}>
        <Field
          id={`radio-${radioEle.type}-${radioEle.index}`.toLowerCase()}
          name={radioEle.type + '_btn_radio'}
          component="input"
          type="radio"
          className="radio-button"
          disabled={disableForm}
          checked={radioEle.checked}
          value={radioEle.document_code}
          onChange={(e) => this.onChangeRadio(e, radioEle.document_code, docTypeString)}
        />
        <span className="radio-label">{radioEle.label}</span>
      </label>
    );

    let defaultCheckedIndex;
    if (typeof changedRadioIndex !== 'number') {
      defaultCheckedIndex = loopArr.findIndex((key) => key.radio_checked);
    }
    if (selectedData) {
      changedRadioIndex = loopArr.findIndex((key) => key.document_code === selectedData);
    }
    const { getAllformVal, dispatch, formName, account_type, remitterCountryCode } = this.props;
    const radioMapping = loopArr.map((ele, index) => {
      ele.checked = changedRadioIndex
        ? index === changedRadioIndex
        : defaultCheckedIndex && defaultCheckedIndex !== -1
        ? index === defaultCheckedIndex
        : index === 0; // changed the changed index to checked take default 0
      const radioInput = generateRadioFields({
          ...ele,
          index
        }),
        fields = fieldsRenderer(ele.fields_json, disableForm, getAllformVal, {
          dispatch,
          change,
          formName,
          isCorp: account_type === CORPORATE
        }),
        links = this.renderUploadLinks({
          linkEle: ele,
          docTypeString,
          index,
          disableForm
        });
      const { label, document_description, document_code, checked, type } = ele;
      let additionalFieldsRender = null;
      if (remitterCountryCode === 'IN') {
        additionalFieldsRender = this.renderAdditionNotesAndViewSample(ele);
      }
      return {
        radioInput,
        fields,
        label,
        document_description,
        links,
        document_code,
        checked,
        type,
        linkConfig: ele,
        additionalFieldsRender
      };
    });
    return radioMapping;
  };

  removeDL_POA = (processesdConfig, type) => {
    const newPOA =
      type === 'POI' &&
      processesdConfig.INDIVIDUAL_POA[1].filter((item) => item.document_code !== 'DRIVING_LICENSE');
    if (type === 'POI') {
      return {
        ...processesdConfig,
        INDIVIDUAL_POA: { 1: newPOA }
      };
    } else {
      return null;
    }
  };

  renderAdditionNotesAndViewSample = (item) => {
    return (
      <div className="updc-info-container">
        <div className="updc-info-title old-info-points-title">Upload your {item.label}</div>
        <div className="updc-info-text">JPEG, PNG or PDF only. Max size 5 MB</div>
        {infoPoints &&
          infoPoints[item.document_code] &&
          infoPoints[item.document_code].map((item, index) => {
            return (
              <div className="updc-points-container" key={index}>
                <img alt="accept" src={item.type === 'accept' ? ACCEPT_ICON : REJECT_ICON} />
                <div className="updc-info-points">{item.text}</div>
              </div>
            );
          })}
      </div>
    );
  };

  setProccessConfigCheck = (type, radioValue) => {
    if (type === 'POI') {
      if (radioValue === 'DRIVING_LICENSE') {
        if (this.removeDL_POA(this.props.processesdConfig, type)) {
          return this.removeDL_POA(this.props.processesdConfig, type);
        }
      }
    }
  };
  updateConfig(radioValue, type) {
    const processedConfig = this.setProccessConfigCheck(type, radioValue);
    const fieldscustom = this.renderFieldsNew(processedConfig);
    this.setState({ fieldscustom });
  }

  onChangeRadio = async (e, radioValue, type) => {
    this.props.country_code === 'CA' &&
      type === 'POI' &&
      (await this.updateConfig(radioValue, type));
    const currentFieldState = { ...this.state.fieldscustom };
    currentFieldState[type].forEach((docEle, index) => {
      if (docEle.radioGroup) {
        this.clearValuesFor({
          ...docEle.radioMapping.find((ele) => ele.checked),
          docType: type
        });
        const changedRadioIndex = docEle.radioMapping.findIndex(
          (ele) => ele.document_code === radioValue
        );
        if (changedRadioIndex || changedRadioIndex === 0) {
          const radiostate = docEle.radioMapping[changedRadioIndex],
            radioMapping = this.renderRadioButtonsNew({
              loopArr: currentFieldState[type][index].radioConfig,
              changedRadioIndex,
              docTypeString: type
            }), // generate new set of radio buttons
            radioGroup = radioMapping.map((key) => {
              return key.radioInput;
            });
          currentFieldState[type][index] = {
            ...currentFieldState[type][index],
            ...radiostate,
            radioGroup,
            radioMapping
          };
        }
      }
    });
    this.setState({ fieldscustom: currentFieldState });
  };

  onChangeFile = ({
    target,
    docTypeString,
    document_code,
    is_back_file,
    webcamData,
    isInvalid,
    type
  }) => {
    if (webcamData) {
      const { dataURL, fileName, extension, imageObj, fieldName } = webcamData;
      this.setFile({
        dataURL,
        fileName: fileName + extension,
        document_code,
        is_back_file,
        docTypeString,
        type
      });
      this.props.dispatch(change(this.props.formName, fieldName, imageObj));
      this.props.dispatch(touch(this.props.formName, fieldName));
      return;
    }
    const input = target;
    let dataURL;
    const reader = new FileReader();
    reader.readAsDataURL(input.files[0]);
    reader.onload = () => {
      // to get dataURL
      dataURL = reader.result;
      this.setFile({
        dataURL,
        fileName: input.files[0].name,
        document_code,
        is_back_file,
        docTypeString,
        isInvalid,
        type
      });
      input.value = ''; //to allow re-selecting of the same file
    };
  };

  setFile = ({
    dataURL,
    fileName,
    document_code,
    is_back_file,
    docTypeString,
    isInvalid,
    type
  }) => {
    const currentFieldState = { ...this.state.fieldscustom };
    !isInvalid && this.props.activeRfiAdditionalDocs && this.props.activeRfiAdditionalDocs(true);
    currentFieldState[docTypeString].forEach((docEle, index) => {
      if (docEle.document_code === document_code && docEle.linkConfig.type === type) {
        currentFieldState[docTypeString][index].linkConfig[
          is_back_file ? 'fileSrcBack' : 'fileSrc'
        ] = isInvalid ? '' : dataURL;
        currentFieldState[docTypeString][index].linkConfig[
          is_back_file ? 'actual_file_name_back' : 'actual_file_name'
        ] = fileName;
        const links = this.renderUploadLinks({
          linkEle: {
            ...currentFieldState[docTypeString][index].linkConfig
          },
          docTypeString,
          index
        });
        currentFieldState[docTypeString][index].links = links;
      }
    });
    this.setState({ fieldscustom: currentFieldState });
  };

  //clear values on radio change
  clearValuesFor = ({ document_code, type, docType }) => {
    const { getAllformVal } = this.props;
    if (!getAllformVal || !getAllformVal[type]) return;
    const setObj = {};
    const untouchObj = {};
    const currentFieldState = { ...this.state.fieldscustom };

    setObj[type] = getAllformVal[type] ? { ...getAllformVal[type] } : {};
    const doc = currentFieldState[docType].find((ele) => ele.document_code === document_code);
    if (doc) {
      //untouch
      const linkConfig = doc.linkConfig;
      let fieldjson = linkConfig.fields_json;
      fieldjson = fieldjson && fieldjson.length > 0 ? fieldjson.map((e) => e.field_name) : [];
      const { file_field_name } = linkConfig;
      const file_field_name_back = file_field_name + '_back';
      fieldjson = [...fieldjson, file_field_name, file_field_name_back];
      fieldjson.forEach((key) => (untouchObj[key] = undefined));
      untouchFields(this.props.dispatch, untouch, this.props.formName, untouchObj);
    }
    if (setObj && getAllformVal[type]) {
      // reset
      delete setObj[type][document_code];
      setReduxFields(this.props.dispatch, change, this.props.formName, setObj);
      currentFieldState[docType].forEach((docEle, index) => {
        //clear files from dom
        if (docEle.document_code === document_code) {
          this.clearFile({ docType, index, setState: false });
        }
      });
      this.setState({ fieldscustom: currentFieldState });
    }
  };

  clearFile = ({ docType, index, setState, fileName, clearOnly, shouldUntouch }) => {
    this.props.activeRfiAdditionalDocs && this.props.activeRfiAdditionalDocs(false);
    const currentFieldState = { ...this.state.fieldscustom };
    const linkEle = currentFieldState[docType][index];

    this.isShowSamplePhoto(true);

    if (clearOnly) {
      linkEle.linkConfig[clearOnly] = null;
    } else {
      linkEle.linkConfig['fileSrc'] = null;
      linkEle.linkConfig['fileSrcBack'] = null;
      linkEle.linkConfig.actual_file_name = null;
      linkEle.linkConfig.actual_file_name_back = null;
    }

    const { file_field_name } = linkEle.linkConfig;
    if (shouldUntouch && file_field_name) {
      this.props.dispatch(change(this.props.formName, file_field_name, ''));
      this.props.dispatch(untouch(this.props.formName, file_field_name));
      this.props.dispatch(change(this.props.formName, file_field_name + '_back', ''));
      this.props.dispatch(untouch(this.props.formName, file_field_name + '_back'));
    }

    const links = this.renderUploadLinks({
      linkEle: {
        ...linkEle.linkConfig
      },
      docTypeString: docType,
      index
    });
    linkEle.links = links;
    if (setState) {
      this.props.dispatch(change(this.props.formName, fileName, ''));
      this.setState({ fieldscustom: currentFieldState });
    }
    return linkEle;
  };

  renderUploadLinks = (props) => {
    const { linkEle } = props;
    //Here 1 is the sequence id. If sequence for ADDRESS_POA_DOCUMENT changeed we should change it.
    if (
      linkEle?.document_input_type === 'FILE' ||
      this.props.processesdConfig?.[0]?.[1]?.[0]?.document_code === ADDRESS_POA_DOCUMENT
    )
      return (
        <FileUploadLinksNew
          {...props}
          clearFile={this.clearFile}
          onChangeFile={this.onChangeFile}
          formName={this.props.formName}
          country_code={this.props.country_code}
          currentScreen={this.props.currentScreen}
          account_type={this.props.account_type}
          validate={this.props.validate}
          isShowSamplePhoto={this.isShowSamplePhoto}
          onSampleClick={this.onSampleClick(linkEle)}
          device={this.props.device}
        />
      );
    return null;
  };

  onEverificationMount = (isEverificationSuccessful) => {
    this.setState({ isEverificationSuccessful });
  };

  renderEverificationBtn = (props, formName) => {
    return (
      <Everify
        field={props}
        formName={formName}
        onEverification={this.onEverification}
        dispatch={this.props.dispatch}
        documentDetails={this.props.documentDetails}
        onEverificationMount={this.onEverificationMount}
      />
    );
  };

  onEverification = (data) => {
    const { screenConfig, documentDetails } = this.props;
    const { processesdConfig } = processesdScreenConfig(screenConfig, documentDetails, data);
    const fieldscustom = this.renderFieldsNew(processesdConfig);
    this.setState({ fieldscustom });
  };

  onSampleClick = (item) => async (el, isBackFile, labelText) => {
    const image = this.getSampleImage(item, isBackFile);
    await this.setState({ sampleImageUrl: image });
    this.showSampleModal(labelText, item.document_code);
  };

  getSampleImage = (item, isBackImage) => {
    const { document_code } = item;
    let frontKey = document_code;
    if (isBackImage) {
      frontKey = `${frontKey}_BACK`;
    }
    return SAMPLE_DOC_IMAGE[frontKey] ? SAMPLE_DOC_IMAGE[frontKey] : SAMPLE;
  };

  showSampleModal = async (labelText, document) => {
    await ModalFactory.builder(
      (onClose) => (
        <div className="logo-modal">
          <img
            src={CLOSE_HEAVY_ICON}
            alt="close icon"
            className="close close-icon"
            onClick={() => onClose(false)}
          />
          <span className="header">{labelText}</span>
          {document === 'PAN' ? (
            <img
              src={this.state.sampleImageUrl}
              alt="sample"
              style={{ width: '100%', padding: '50px' }}
            />
          ) : (
            <div className="image-text-div">
              <img src={this.state.sampleImageUrl} alt="sample" style={{ marginTop: '40px' }} />
              <div className="notes" id="notes">
                <span className="self-text">Self attestation required</span>
                <img alt="signature" src={YOUR_SIGNATURE_ICON} className="signature-img"></img>
                <span className="write-your-name">Write your name</span>
                <span className="write-your-name">Current date</span>
              </div>
            </div>
          )}
          <button className="close-button" onClick={() => onClose(false)}>
            Close
          </button>
        </div>
      ),
      'send-money-bene-modal insta-modal center-modal sample-modal',
      true
    );
  };

  renderBankStatementSampleModal = async () => {
    //@ts-ignore
    await ModalFactory.builder(
      (onClose) => (
        <>
          <div className="modalContainer">
            <div className="modal-heading">{BANK_STATEMENT_INSTRUCTIONS.bankStatementText} </div>
            <div className="sub-heading">{BANK_STATEMENT_INSTRUCTIONS.sampleIllustration} </div>
            <img className="bank-statement" src={BANK_STATEMENT_SAMPLE} alt="sample" />
            {this.props.userStatus !== ACKNOWLEDGED && (
              <div className="description">
                {BANK_STATEMENT_INSTRUCTIONS.bankStatementGuideLine}
              </div>
            )}
            <div className="button-wrapper">
              <CommonButton text="Got it" onClick={onClose} width={422} />
            </div>
          </div>
        </>
      ),
      'render-bank-statement-sample-modal insta-modal center-modal',
      true
    );
  };

  getSampleModalImage = (title) => {
    if (!title) return null;
    const lowerTitle = title.toLowerCase();
    if (lowerTitle.includes('epass') || lowerTitle.includes('e-pass'))
      return `${BASE_CDN_IMAGE_URL}/malaysia-epass.svg`;
    if (lowerTitle.includes('evisa') || lowerTitle.includes('e-visa'))
      return `${BASE_CDN_IMAGE_URL}/malaysia-evisa.svg`;
    return null;
  };

  renderNestedSampleModal = async () => {
    const { selectedSampleModal } = this.state;
    const sampleImage = this.getSampleModalImage(selectedSampleModal?.title);
    //@ts-ignore
    await ModalFactory.builder(
      (onClose) => (
        <>
          <div className="modalContainer evisa-sample-modal">
            {selectedSampleModal?.title && (
              <div className="modal-heading">{selectedSampleModal.title}</div>
            )}
            {selectedSampleModal?.subtitle && (
              <div className="sub-heading">{selectedSampleModal.subtitle}</div>
            )}
            {sampleImage && (
              <div className="sample-image-wrapper">
                <img
                  src={sampleImage}
                  alt={selectedSampleModal?.title || 'sample'}
                  className="sample-doc-image"
                />
              </div>
            )}
            {selectedSampleModal?.description && (
              <div className="description">{selectedSampleModal.description}</div>
            )}
            <div className="button-wrapper">
              <CommonButton text="Got it" onClick={onClose} width={422} />
            </div>
          </div>
        </>
      ),
      'evisa-sample-modal-wrapper insta-modal center-modal',
      true
    );
  };

  renderFileUploadDescription = (descriptionText) => {
    const descriptions = (descriptionText || '')
      .split('|')
      .map((item) => item.trim())
      .filter((item) => item !== '');

    if (!descriptions.length) return null;

    return (
      <>
        <div className="rfi-intro">{descriptions[0]}</div>
        {descriptions.length > 1 && (
          <ul className="bullet-list">
            {descriptions.slice(1).map((desc, index) => (
              <li key={index} className="rfi-description">
                {desc}
              </li>
            ))}
          </ul>
        )}
      </>
    );
  };

  fieldscustomTemplate = (type) => (
    <Grid.Row className="row-3 space-between">
      {this.state.fieldscustom[type].map((doc, index) => {
        return [
          doc.radioGroup && (
            <Grid.Column width={16} computer={15} mobile={16} tablet={16} key={'radio' + index}>
              {doc.radioGroup}
            </Grid.Column>
          ),
          doc.document_code !== ADDRESS_POA_DOCUMENT && (
            <Grid.Column width={16} computer={15} mobile={16} tablet={16} key={'head' + index}>
              <div className="heading">
                {!SUPPORTED_BANK_STATEMENT_DOC_TYPES.includes(doc.document_code) && (
                  <p className="main-label">{doc.label}</p>
                )}
                <p className="default-text">{doc.document_description}</p>
                {SUPPORTED_BANK_STATEMENT_DOC_TYPES.includes(doc.document_code) && (
                  <p>
                    Click on{' '}
                    <CommonButton
                      text={BANK_STATEMENT_INSTRUCTIONS.viewSampleText}
                      type="link"
                      onClick={this.renderBankStatementSampleModal}
                    />{' '}
                    to see visual examples that explain the requirements.
                  </p>
                )}
              </div>
            </Grid.Column>
          ),
          doc.fields,
          !isEmpty(this.state.selectedNestedRadioField) && (
            <>
              <div className="radio-field-description sixteen wide column">
                {this.state.selectedNestedRadioField?.description}
              </div>
              <div className="nested-radio-fields sixteen wide column">
                {this.state.renderingRadioNestedFields}
              </div>
              {doc.linkConfig?.file_upload_title || doc.linkConfig?.file_upload_description ? (
                <div
                  className="radio-file-upload-title fifteen wide computer 
      sixteen wide mobile sixteen wide tablet sixteen wide column"
                >
                  {doc.linkConfig?.file_upload_title}
                  <div className="radio-file-upload-description">
                    {this.renderFileUploadDescription(doc.linkConfig?.file_upload_description)}
                  </div>
                </div>
              ) : (
                (this.state.selectedNestedRadioField?.show_upload_button ||
                  this.state.selectedNestedRadioField?.show_capture_button) && (
                  <div
                    className="radio-file-upload-title fifteen wide computer 
        sixteen wide mobile sixteen wide tablet sixteen wide column"
                  >
                    {this.state.selectedNestedRadioField?.file_upload_title}
                    <div className="radio-file-upload-description">
                      {this.state.selectedNestedRadioField?.file_upload_description}
                    </div>
                  </div>
                )
              )}
            </>
          ),
          <Grid.Column
            width={16}
            computer={15}
            mobile={16}
            tablet={16}
            className="fields-col doc-links"
            key={'fields-verify' + index}
          >
            {doc.verifyBtn}
          </Grid.Column>,
          doc.additionalFieldsRender && (
            <Grid.Column
              width={16}
              computer={15}
              mobile={16}
              tablet={16}
              className="fields-col doc-links"
              key={'fields-info' + index}
            >
              {doc.additionalFieldsRender}
            </Grid.Column>
          ),
          /*Checks if we have nested field inside radio and showing Document upload/capture 
          only for the selected radio config if the upload buttons are true inside the selected radio field
          */
          !isEmpty(this.state.radioNestedFields) &&
            !isEmpty(this.state.selectedNestedRadioField) &&
            (this.state.selectedNestedRadioField?.show_upload_button ||
              this.state.selectedNestedRadioField?.show_capture_button) && (
              <Grid.Column
                width={16}
                computer={15}
                mobile={16}
                tablet={16}
                className="fields-col doc-links"
              >
                <FileUploadLinksNew
                  {...this.props}
                  docTypeString={type}
                  index={index}
                  clearFile={this.clearFile}
                  onChangeFile={this.onChangeFile}
                  formName={this.props.formName}
                  linkEle={{
                    ...doc.linkConfig,
                    ...this.state.selectedNestedRadioField,
                    document_code: doc.document_code
                  }}
                  isShowSamplePhoto={this.isShowSamplePhoto}
                />
              </Grid.Column>
            ),
          //For all other rfis which dont have nested field inside radio group
          doc.document_code !== ADDRESS_POA_DOCUMENT && (
            <Grid.Column
              width={16}
              computer={15}
              mobile={16}
              tablet={16}
              className="fields-col doc-links"
              key={'fields' + index}
            >
              {doc.links}
            </Grid.Column>
          )
        ];
      })}
    </Grid.Row>
  );

  getBoldText = (text, boldValue) => {
    const highlightedText = text?.split(boldValue)?.map((part, index, arr) =>
      index < arr.length - 1 ? (
        <React.Fragment key={index}>
          {part}
          <span className="name">{boldValue}</span>
        </React.Fragment>
      ) : (
        part
      )
    );
    return <>{highlightedText}</>;
  };

  getSubContent = (
    is_kyc_oriented,
    is_transaction_oriented,
    expiry_date,
    rfiDetailsCmsData,
    date_time,
    lessThanFourDaysRem
  ) => {
    let title = '';
    let subTitle = '';

    if (is_kyc_oriented && expiry_date) {
      title = compileTemplateNew(rfiDetailsCmsData?.submittedBy, { date_time });
      subTitle = rfiDetailsCmsData?.note1;
    } else if (is_transaction_oriented && expiry_date && !lessThanFourDaysRem) {
      title = compileTemplateNew(rfiDetailsCmsData?.submittedBy, { date_time });
      subTitle = rfiDetailsCmsData?.note2;
    } else if (is_transaction_oriented && expiry_date) {
      title = compileTemplateNew(rfiDetailsCmsData?.submittedIn, { date_time });
      subTitle = rfiDetailsCmsData?.note2;
    } else {
      title = rfiDetailsCmsData?.kycNonExpiryNote1;
      subTitle = rfiDetailsCmsData?.kycNonExpiryNote2;
    }

    return (
      <div>
        <span className="title">{title}</span>
        <span className="sub-title">{` ${subTitle}`}</span>
      </div>
    );
  };

  getSectionTitle = (type) => {
    const { currentScreen, sectionHead, country_code } = this.props;
    const sectionName = (() => {
      const isUSCountry = country_code === 'US';
      const isInCountry = country_code === 'IN';
      switch (currentScreen) {
        case SCREEN_NAME_DOCUMENT_UPLOAD: {
          if (type === 'POI')
            return isUSCountry ? 'Identity Proof (any one of the below)' : 'Identity Proof';
          else
            return isUSCountry || isInCountry
              ? 'Address Proof (any one of the below)'
              : 'Address Proof';
        }
        case SCREEN_NAME_PHOTO_UPLOAD: {
          return null;
        }
        default:
          return null;
      }
    })();

    if (sectionName) {
      return <div className="form-flow-header">{sectionName}</div>;
    } else if (sectionHead) {
      const { processesdConfig, rfiCmsData, userStatus } = this.props;
      const keys = Object.keys(processesdConfig[0]);
      const headConfigData = processesdConfig[0][keys[0]] || null;
      const transactionNumber = get(headConfigData[0], 'transaction_number', false);
      const doc_description = get(headConfigData[0], 'descrioption', false);
      const rfiDescription = get(headConfigData[0], 'rfi_description') ?? false;
      const rfiDescriptionData = rfiDescription
        ? rfiDescription.split('|')?.map((item) => item.trim()) || []
        : [];
      const is_kyc_oriented = get(headConfigData[0], 'is_kyc_oriented', false);
      const is_transaction_oriented = get(headConfigData[0], 'is_transaction_oriented', false);
      const expiry_date = get(headConfigData[0], 'expiry_date', false);
      const rfiExpirydate = moment(expiry_date).format('MMM DD');
      const rfiExpiryTime = moment(expiry_date).format('h:mm a');
      const timeLeftInHours = moment(expiry_date) - moment();
      const hours = Math.floor(timeLeftInHours / (1000 * 60 * 60));
      const document_code = get(headConfigData[0], 'document_code', '');
      const label = get(headConfigData[0], 'label', '');

      const date_time =
        is_transaction_oriented && hours <= 96 ? `${hours}` : `${rfiExpirydate}, ${rfiExpiryTime}`;
      const rfiDetailsCmsData = rfiCmsData?.rfiScreen || RFIDATA?.rfiScreen;
      const isExpiryDateAlreadyBreached = moment().isAfter(moment(expiry_date));

      //for POA Rfis if user status is ACKNOWLEDGED  need to hide subcontent
      const shouldShowSubContent = userStatus !== ACKNOWLEDGED && !isExpiryDateAlreadyBreached;
      const showTransactioKey = transactionNumber ? (
        <span id="transaction-text" style={{ marginLeft: '10px' }}>
          ( Transaction Number
          <span id="transaction-number"> {transactionNumber}</span> )
        </span>
      ) : null;
      return [
        <div className="form-flow-header rfi-header" key="section-head">
          {sectionHead}
          {showTransactioKey}
        </div>,
        <>
          {document_code === 'FIN' && (
            <div className="fin-info-message">
              <img className="info-icon" src={INFO_NEW_ICON} alt="info" />
              <div className="heading">
                {this.getBoldText(
                  rfiDetailsCmsData?.noteNRIC?.noteWeb || NOTE_NRIC.note,
                  rfiDetailsCmsData?.noteNRIC?.boldText || NOTE_NRIC.boldText
                )}
                <span>
                  <HelpCenterDeepLink cmsKey="rfiUploadNricWeb" />
                </span>
              </div>
            </div>
          )}

          {shouldShowSubContent && (
            <div className="wrapper">
              <img src={PINK_ELIPSE_ICON} alt="pink-ellipse-icon" className="ellipse-icon" />
              <span className="sub-content-wrapper">
                {this.getSubContent(
                  is_kyc_oriented,
                  is_transaction_oriented,
                  expiry_date,
                  rfiDetailsCmsData,
                  date_time,
                  hours <= 96
                )}
              </span>
            </div>
          )}
        </>,

        doc_description?.map(({ title, descrioption }) => {
          return (
            <>
              {rfiDescription ? (
                <>
                  {label && <p className="label-sub-heading">{label}</p>}
                  <ul className="bullet-list">
                    {rfiDescriptionData.map((description, index) => (
                      <li key={index} className="rfi-description">
                        {description}
                      </li>
                    ))}
                  </ul>
                </>
              ) : descrioption ? (
                <ol className="ordered-list">
                  {descrioption.map((description, index) => (
                    <li key={index} className="rfi-description">
                      {description}
                    </li>
                  ))}
                </ol>
              ) : null}

              {!SUPPORTED_BANK_STATEMENT_DOC_TYPES.includes(document_code) && (
                <p className="rfi-title" key={title}>
                  {title}
                </p>
              )}
            </>
          );
        })
      ];
    } else {
      return null;
    }
  };

  isShowSamplePhoto = (flag = true) => {
    this.setState({ isShowSamplePhotograph: flag });
  };

  render() {
    const { currentScreen, country_code, skipScreen, isEmbeddedSection, removePadding, sectionHead } =
      this.props;
    const { fieldscustom, isEverificationSuccessful } = this.state;
    const noPadClass = `${removePadding ? 'no-padding' : ''}`;

    return (
      <UploadDocsFields
        currentScreen={currentScreen}
        country_code={country_code}
        isEmbeddedSection={isEmbeddedSection}
        sectionHead={sectionHead}
        skipScreen={skipScreen}
        fieldscustom={fieldscustom}
        isEverificationSuccessful={isEverificationSuccessful}
        noPadClass={noPadClass}
        fieldscustomTemplate={this.fieldscustomTemplate}
        getSectionTitle={this.getSectionTitle}
        isShowSamplePhotograph={this.state.isShowSamplePhotograph}
        noButtonNeeded={this.props.noButtonNeeded}
        userAddress={this.props.userAddress}
      />
    );
  }
}

UploadDocuments.propTypes = {
  processesdConfig: PropTypes.any,
  currentScreen: PropTypes.string,
  documentDetails: PropTypes.array,
  dispatch: PropTypes.func,
  getAllformVal: PropTypes.any,
  country_code: PropTypes.string,
  account_type: PropTypes.string,
  skipScreen: PropTypes.func,
  formName: PropTypes.string,
  validate: PropTypes.array,
  linkEle: PropTypes.object,
  reRenderOnUpdate: PropTypes.bool,
  disableDocs: PropTypes.bool,
  isEmbeddedSection: PropTypes.bool,
  sectionHead: PropTypes.string,
  sectionSubHead: PropTypes.string,
  screenConfig: PropTypes.object,
  removePadding: PropTypes.any,
  disableForm: PropTypes.bool,
  noButtonNeeded: PropTypes.bool,
  activeRfiAdditionalDocs: PropTypes.func,
  remitterCountryCode: PropTypes.string,
  device: PropTypes.string,
  rfiCmsData: PropTypes.object,
  fetchUserAddress: PropTypes.func,
  userAddress: PropTypes.object,
  setResetRadioQuestionField: PropTypes.func,
  setResetRadioKycScenario: PropTypes.func,
  userStatus: PropTypes.string
};

function mapStateToProps(store) {
  const {
    rootReducer: {
      userStatusReducer: { country_code: remitterCountryCode, status: userStatus },
      uiTriggerState: { device },
      dashboardReducer: { rfiCmsData }
    }
  } = store;

  return {
    remitterCountryCode,
    device,
    rfiCmsData,
    userStatus
  };
}

export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(
    {
      changeScreen,
      dispatch
    },
    dispatch
  )
)(UploadDocuments);
